// @flow
import Tabs from '@shared/Navigation/Tabs/components/Tabs';

export default Tabs;
